/**
 * Parça tipinin metadata alan tanımları editörü.
 * Her satır: anahtar (örn. hardwareId) + "Benzersiz" seçimi — benzersiz
 * işaretlenirse aynı değer başka bir parça ünitesine yazılamaz (sunucu 409).
 */
export default function MetadataFieldsEditor({ value = [], onChange }) {
  const setField = (idx, patch) =>
    onChange(value.map((f, i) => (i === idx ? { ...f, ...patch } : f)));
  const removeField = (idx) => onChange(value.filter((_, i) => i !== idx));
  const addField = () => onChange([...value, { key: "", unique: false }]);

  return (
    <div>
      <span className="block text-sm font-Medium text-gray-700 mb-1">
        Metadata Alanları
      </span>
      <p className="text-xs text-gray-400 mb-2">
        Bu parça tipinin ünitelerine yazılabilecek veri anahtarları (örn.
        hardwareId). Yalnız harf, rakam, altçizgi ve tire kullanın.
      </p>
      <div className="flex flex-col gap-2">
        {value.map((f, idx) => (
          <div key={idx} className="flex items-center gap-2">
            <input
              type="text"
              value={f.key}
              onChange={(e) => setField(idx, { key: e.target.value })}
              placeholder="anahtar (örn. hardwareId)"
              className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono"
            />
            <label className="flex items-center gap-2 text-sm text-gray-600 shrink-0">
              <input
                type="checkbox"
                checked={Boolean(f.unique)}
                onChange={(e) => setField(idx, { unique: e.target.checked })}
                className="w-4 h-4"
              />
              Benzersiz
            </label>
            <button
              type="button"
              onClick={() => removeField(idx)}
              className="text-sm text-red-500 hover:text-red-700 px-2 py-1 shrink-0"
            >
              Kaldır
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={addField}
        className="mt-2 text-sm text-blue-600 hover:text-blue-800"
      >
        + Alan Ekle
      </button>
    </div>
  );
}
